import { render, staticRenderFns } from "./EmptyDataset.vue?vue&type=template&id=071a3e14&scoped=true&"
import script from "./EmptyDataset.vue?vue&type=script&lang=js&"
export * from "./EmptyDataset.vue?vue&type=script&lang=js&"
import style0 from "./EmptyDataset.vue?vue&type=style&index=0&id=071a3e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a3e14",
  null
  
)

export default component.exports